import { RootState } from "@/store/types";
import { Module } from "vuex";
import { actions } from "./actions";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { TowerState } from "./types";

export const AREA_LIST_KEY = "area";

export const initialState = function(): TowerState {
  return {
    data: {
      towerReview: []
    },
    error: false
  };
};

export const state: TowerState = initialState();

export const towerNamespace = { namespace: "tower" };

const namespaced: boolean = true;

export const tower: Module<TowerState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
